
import { useState, useEffect } from 'react';

const universityImages = [
  {
    url: 'https://public.readdy.ai/ai/img_res/1c652748d246090d8ef7e71b3f6dc650.jpg',
    title: 'Almanya\'da Prestijli Üniversiteler'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=international%20students%20studying%20together%20in%20modern%20university%20library%20in%20germany%20diverse%20group%20of%20young%20people%20learning%20academic%20atmosphere%20bright%20natural%20light&width=1400&height=700&seq=uni-hero-002&orientation=landscape',
    title: 'Uluslararası Öğrenci Topluluğu'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=beautiful%20german%20university%20graduation%20ceremony%20students%20in%20academic%20gowns%20celebrating%20success%20outdoor%20campus%20setting%20sunny%20day%20joyful%20atmosphere&width=1400&height=700&seq=uni-hero-003&orientation=landscape',
    title: 'Başarılı Mezuniyet'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=modern%20german%20university%20lecture%20hall%20with%20students%20attending%20class%20contemporary%20education%20facility%20bright%20interior%20professional%20academic%20setting&width=1400&height=700&seq=uni-hero-004&orientation=landscape',
    title: 'Modern Eğitim Ortamı'
  }
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % universityImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="anasayfa" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
      {/* Image Slider Background */}
      <div className="absolute inset-0 z-0">
        {universityImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image.url}
              alt={image.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a1a]/60 via-[#1a1a1a]/40 to-[#1a1a1a]/70"></div>
          </div>
        ))}
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-32 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {universityImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-[#FFCE00] w-8' : 'bg-white/50'
            }`}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 py-32 text-center w-full">
        <div className="max-w-4xl mx-auto">
          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
            Almanya&apos;da Eğitim
            <br />
            <span className="text-[#FFCE00]">
              Hayalinizi Gerçekleştirin
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed">
            Türkiye&apos;den Almanya&apos;ya gelmek isteyen öğrenciler için lisans, yüksek lisans ve dil okulu başvurularında profesyonel danışmanlık hizmeti sunuyoruz.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#randevu"
              className="w-full sm:w-auto px-8 py-4 bg-[#DD0000] text-white text-lg font-bold rounded-lg hover:bg-[#bb0000] hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              Ücretsiz Randevu Al
            </a>
            <a
              href="#bilgi-formu"
              className="w-full sm:w-auto px-8 py-4 bg-[#FFCE00] text-[#1a1a1a] text-lg font-bold rounded-lg hover:bg-[#e6b800] hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              Bilgi Formu Doldur
            </a>
            <button
              type="button"
              className="w-full sm:w-auto px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/30 text-white text-lg font-semibold rounded-lg cursor-default opacity-60 whitespace-nowrap flex items-center justify-center gap-2"
              disabled
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - Arrow Only */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#hizmetler" className="flex flex-col items-center gap-2 text-white hover:text-[#FFCE00] transition-colors cursor-pointer">
          <i className="ri-arrow-down-double-line text-4xl"></i>
        </a>
      </div>
    </section>
  );
}
